import { render, staticRenderFns } from "./AxiosLoading.vue?vue&type=template&id=048f695a&scoped=true&"
import script from "./AxiosLoading.vue?vue&type=script&lang=js&"
export * from "./AxiosLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f695a",
  null
  
)

export default component.exports